import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";

const _base = "networkCourse/";

// 线上学习课程 - 我的网络课程列表-分页
export const myCourseList = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "myCourseList", {
           data: _params,
           method: "GET",
         });
       };

// 线上学习课程 - 获取课程详情-录播
export const courseInfo = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "courseInfo", {
           data: _params,
           method: "GET",
         });
       };
// 线上学习课程 - 获取直播课程详情
export const liveCourseInfo = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "liveCourseInfo", {
           data: _params,
           method: "GET",
         });
       };
// 线上学习课程 - 获取课程所有章类型列表
export const chapterTreeList = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "chapterTreeList", {
           data: _params,
           method: "GET",
         });
       };

// 线上学习课程 - 获取课程课件资源（含视频和文档）
export const teachMaterialList = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "teachMaterialList", {
           data: _params,
           method: "GET",
         });
       };
// 线上学习课程 - 获取课件资源路径
export const getMaterialPath = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "getMaterialPath", {
           data: _params,
           method: "GET",
         });
       };

// 线上学习课程 - 我的网络课程列表-5条(首页)
export const myHomeCourseList = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "myHomeCourseList", {
           data: _params,
           method: "GET",
         });
       };
// 线上学习课程 - 获取第三方视频资源信息
export const getVideoSign = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "getVideoSign", {
           data: _params,
           method: "GET",
         });
       };
//  /**
//      * 获取欠费情况
//      *
//      * @return feeStatus 欠费状态：0-没有缴费记录，1-欠费，2-已交完
//      */
export const getFeeInfo = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "feeInfo", {
           data: _params,
           method: "GET",
         });
       };

// 获取整门课程学习进度
export const getCourseRadio = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "courseRadio", {
           data: _params,
           method: "GET",
         });
       };

// 获取某门课程所有学习记录
export const getCourseLearnRecord = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "courseLearnRecord", {
           data: _params,
           method: "GET",
         });
       };

// 获取某门课程所有学习记录
export const getCourseMaterialList = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "courseMaterialList", {
           data: _params,
           method: "GET",
         });
       };



// WEBPACK FOOTER //
// ./src/fetch/api/study.js